
import React, { useEffect } from "react";
import { z } from "zod";
import { advancedTierSchema } from "@/contexts/program-creation/types";
import TierQuestions from "./TierQuestions";
import AdvancedTierFormContent from "./advanced-tier/AdvancedTierFormContent";
import { 
  ADVANCED_TIER_DEFAULT_VALUES, 
  ADVANCED_TIER_TITLE, 
  ADVANCED_TIER_DESCRIPTION 
} from "./advanced-tier/constants";

type AdvancedTierQuestionsProps = {
  onSubmit: (data: z.infer<typeof advancedTierSchema>) => void;
  onBack: () => void;
  isSaving: boolean;
};

export default function AdvancedTierQuestions({ 
  onSubmit, 
  onBack, 
  isSaving 
}: AdvancedTierQuestionsProps) {
  // Load saved data or use default values
  const savedDataString = localStorage.getItem('tierData');
  const savedData = savedDataString ? JSON.parse(savedDataString) : null;
  
  // Get initial values from saved data or use defaults
  const initialValues = savedData || ADVANCED_TIER_DEFAULT_VALUES;

  const handleFormSubmit = (formData: z.infer<typeof advancedTierSchema>) => {
    // Save form data to local storage to ensure it's available for review
    localStorage.setItem('tierData', JSON.stringify(formData));
    // Pass the data to the parent component
    onSubmit(formData);
  };

  return (
    <TierQuestions
      title={ADVANCED_TIER_TITLE}
      description={ADVANCED_TIER_DESCRIPTION}
      schema={advancedTierSchema}
      defaultValues={initialValues}
      onSubmit={handleFormSubmit}
      onBack={onBack}
      isSaving={isSaving}
    >
      {(form) => <AdvancedTierFormContent form={form} />}
    </TierQuestions>
  );
}
